<template>
  <footer class="footerBottom">
    <!-- <div class="top"></div> -->
    <div class="content">
      <!-- <div class="left">
        <div class="left_left">
          <div class="left_left_title">快速入口</div>
          <div class="left_left_content" @click="goRouter">
            <p>旅游资源普查数据管理系统</p>
          </div>
        </div>
        <div class="left_right">
          <div class="left_right_title">关注我们</div>
          <div class="left_left_content">
            <div class="imgs">
              <div class="imgs_left">
                <div class="img"><img :src="wxTitleImg" alt="" /></div>
                <div class="imgs_left_des">{{ wxTitle }}</div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
      <div class="content_content"></div>
      <div class="right">
        <ul>
          <div class="right_title">关于我们</div>
          <li>联系电话：+86 200-464-2853</li>
          <li>ICP备案号：陇ICP备15001598号-3</li>
          <li>地址信息：甘肃省兰州市城关区东岗西路638号</li>
        </ul>
      </div> -->
    </div>
    <!-- <div class="bottom"></div> -->
    <!-- <div class="footerRow">
      <div class="left">
        <div class="top">
          <img class="imglog" src="../../../static/image/home/logo.png" alt="" />
        </div>
        <div class="bottom">
          旅游云门户是了解甘肃省旅游普查工作的窗口，也是使用甘肃省旅游资源普查数据系统的入口，门户系统实现资源的整合。
        </div>
      </div>
      <div class="right">
        <div class="right_left">
          <div class="title">关于我们</div>
          <div class="content">
            <ul>
              <li>联系电话：+86 200-464-2853</li>
              <li>版权所有：甘肃省文化和旅游厅版权所有</li>
              <li>ICP备案号：陇ICP备15001598号-3</li>
              <li>地址信息：甘肃省兰州市城关区东岗西路638号</li>
            </ul>
          </div>
        </div>
        <div class="right_right">
          <div class="title">关注我们</div>
          <div class="qrcode">
            <img :src="footerBottom.sweepTheAttention" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="left">主办单位：甘肃省文化和旅游厅</div>
      <div class="right">甘公安备：62010203000879</div>
    </div> -->
  </footer>
</template>

<script>
export default {
  name: 'footerBottom',
  data() {
    return {
      wxTitle: window.g.wxTitle,
      wxTitleImg: window.g.wxImg,
      footerBottom: window.g.footerBottom,
    };
  },
  created() { },
  mounted() { },
  methods: {
    goRouter() {
      window.open('http://60.13.8.238:7702/TPDm', '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.footerBottom {
  position: relative;

  .top {
    height: 1.2rem;
    background: #3b71ea;
  }

  .content {
    background-image: url('../../assets/image/Home/footer.png');
    background-size: 100% 100%;
    position: absolute;
    bottom: -300px;
    padding: 0 31rem;
    height: 22.4rem;
    width: 100%;
    // background: #ffffff;
    display: flex;
    align-items: center;

    .left {
      width: 50%;
      height: 100%;
      display: flex;
      padding-top: 4rem;

      .left_left {
        .left_left_title {
          font-size: 1.8rem;
          font-weight: 600;
          color: #000;
        }

        .left_left_content {
          font-size: 1.8rem;
          font-weight: 400;
          color: #000;
          margin-top: 2.4rem;
          cursor: pointer;
        }
      }

      .left_right {
        margin-left: 10.6rem;

        .left_right_title {
          font-size: 1.8rem;
          font-weight: 600;
          color: #000;
        }

        .left_left_content {
          width: 21rem;
          margin-top: 1.7rem;

          .imgs {
            display: flex;
            justify-content: space-between;

            .imgs_left,
            .imgs_right {
              display: flex;
              flex-direction: column;
              align-items: center;
            }

            .imgs_left_des,
            .imgs_right_des {
              font-size: 1.8rem;
              font-weight: 400;
              color: #000;
            }

            .img {
              width: 8rem;
              height: 8rem;

              // background: #000;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }

    .content_content {
      width: 1px;
      height: 99px;
      background: #333333;
    }

    .right {
      width: 50%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      padding-top: 4rem;

      .right_title {
        font-size: 1.8rem;
        font-weight: 600;
        color: #000;
        margin-bottom: 3rem;
      }

      ul {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        li {
          font-size: 1.8rem;
          font-weight: 400;
          color: #000;
          line-height: 3rem;
        }
      }
    }
  }

  .bottom {
    height: 6.3rem;
    background: #f9fbfc;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commonView/footerBottom.vue